import axios from 'axios';
import config from '../config';
import { getUserToken } from '../utils/helper';

export const GET_LOGS = 'GET_LOGS';
export const GET_LOGS_SUCCESS = 'GET_LOGS_SUCCESS';
export const GET_LOGS_FAIL = 'GET_LOGS_FAIL';
export const GET_LOGS_RESET = 'GET_LOGS_RESET';

export const getLogs = (params) => {
    return {
        type: GET_LOGS,
        params,
    };
};

export const getLogsSuccess = (response) => {
    return {
        type: GET_LOGS_SUCCESS,
        response,
    };
};

export const getLogsFail = (response) => {
    return {
        type: GET_LOGS_FAIL,
        response,
    };
};

export const getLogsReset = () => {
    return {
        type: GET_LOGS_RESET,
    };
};

export const getLogsApi = (data) => {
    return (dispatch) => {
        dispatch(getLogs());
        axios
            .get(`${config.api.base_url}/ml-logs/logs`, {
                params: data,
                headers: {
                    Authorization: 'Bearer ' + getUserToken(),
                },
            })
            .then((response) => {
                const getLogsData = response.data;
                dispatch(getLogsSuccess(getLogsData));
            })
            .catch((error) => {
                const errorMsg = error.message;
                dispatch(getLogsFail(errorMsg));
            });
    };
};
